import {getUrlPath} from "./get-url-path.ts";

interface GetLoginUrlFn {
    /**
     * Get a URL for going to the login route, with associated continue path.
     *
     * This uses our underlying URL builder factory and the URL rules set with
     * `configureUrlConstructionRules` to build the correct URL, including any
     * relevant params. This is equivalent to calling
     * `urlBuilderFactory(path)(continuePath)`.
     *
     * @throws KAError if the path is not configured by the current app.
     * @param continuePath The continue path to append to the URL.
     * @returns The URL path.
     */
    (continuePath?: Nullable<string>): string;

    /**
     * Get a URL to the login route, with associated params.
     *
     * This uses our underlying URL builder factory and the URL rules set with
     * `configureUrlConstructionRules` to build the correct URL, including any
     * relevant params. This is equivalent to calling
     * `urlBuilderFactory(path)(params)`.
     *
     * @throws KAError if the path is not configured by the current app.
     * @param params The params to append to the URL.
     * @returns The URL path.
     */
    (params: Record<string, string>): string;

    /**
     * Get a URL to the login route, with associated params.
     *
     * This uses our underlying URL builder factory and the URL rules set with
     * `configureUrlConstructionRules` to build the correct URL, including any
     * relevant params. This is equivalent to calling
     * `urlBuilderFactory(path)(params)`.
     *
     * @throws KAError if the path is not configured by the current app.
     * @param params The params to append to the URL.
     * @returns The URL path.
     */
    (params: URLSearchParams): string;
}

export const getLoginUrl: GetLoginUrlFn = (continueUrlOrParams: any) =>
    getUrlPath("login", continueUrlOrParams);
